import { render, staticRenderFns } from "./DishName.vue?vue&type=template&id=77180f8a&lang=pug"
import script from "./DishName.vue?vue&type=script&lang=js"
export * from "./DishName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports